const HttpMethods = Object.freeze({
  GET: "GET",
  POST: "PST",
  PUT: "PUT",
  DELETE: "DLT",
  PATCH: "PTC",
});

export default HttpMethods;
